/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { MetaSchema } from './MetaSchema';

export const DraftCreateMetaSchema: core.serialization.Schema<
    serializers.DraftCreateMetaSchema.Raw,
    Truvity.DraftCreateMetaSchema
> = core.serialization.undiscriminatedUnion([MetaSchema, core.serialization.string()]);

export declare namespace DraftCreateMetaSchema {
    export type Raw = MetaSchema.Raw | string;
}
